import moment from 'moment'
import { notification, Modal } from 'ant-design-vue'
import { cloneDeep } from 'lodash'
import { pinyin } from 'pinyin-pro'
// 设置页面标题
export function setPageTitle(titleText) {
  window.document.title = `${titleText}`
}
// 判断是否是数组
export function isArray(obj) {
  if (!obj) return false;
  return Object.prototype.toString.call(obj) == '[object Array]';
}
// 判断是否是对象
export function isObject(obj) {
  if (!obj) return false;
  return Object.prototype.toString.call(obj) == '[object Object]';
}
// 创建GET请求地址
export function createGetUrl(baseUrl, data) {
  if (!baseUrl) return false
  if (!data || !isObject(data)) return false
  let url = baseUrl + '?'
  for (let k in data) {
    url = `${url}${k}=${data[k]}&`
  }
  url = url.substring(0, url.length - 1)
  return url
}
// 判断是否是布尔值
export function isBoolean(val) {
  return typeof val === "boolean"
}
// 存Session
export function setSession(key, value) {
  if (!key || !value) return false
  if (isArray(key) || isObject(key) || isBoolean(key)) return false
  if (isArray(value) || isObject(value)) {
    window.sessionStorage.setItem(key, JSON.stringify(value));
    return true;
  }
  window.sessionStorage.setItem(key.toString(), value.toString())
  return true

}
//取Session
export function getSession(key, def) {
  if (!key) return undefined;
  if (def == 'object' || def == 'array') {
    try {
      return JSON.parse(window.sessionStorage.getItem(key));
    } catch (error) {
      return undefined;
    }
  } else {
    return window.sessionStorage.getItem(key)
  }

}
// 存Local
export function setLocal(key, value) {
  if (!key || !value) return false;
  if (isArray(key) || isObject(key) || isBoolean(key)) return false;
  if (isArray(value) || isObject(value)) {
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  }
  window.localStorage.setItem(key.toString(), value.toString());
  return true;
}
//取local
export function getLocal(key, def) {
  if (!key) return undefined;
  if (def == 'object' || def == 'array') {
    try {
      return JSON.parse(window.localStorage.getItem(key));
    } catch (error) {
      return undefined;
    }
  } else {
    return window.localStorage.getItem(key)
  }
}
/**
 * @转换日期格式
 * @val 传入时间戳
 * @ type 1 -- 'YYYY-MM-DD’
 * @ type 2 -- 'YYYY-MM'
 * @ type 3 -- 'YYYY-MM-DD HH:mm:ss'
 * @ type 4 -- 'YYYY年MM月'
 * @ type 5 -- 'YYYY年MM月DD日'
 * @ type 6 -- 返回时间戳
 * @ type 7 -- 获取十分秒
 **/
export function switchTimeFormat(val, type) {
  if (!val) val = new Date().valueOf()
  let ret = ''
  switch (type) {
    case 1:
      ret = moment(val).format('YYYY-MM-DD');
      break;
    case 2:
      ret = moment(val).format('YYYY-MM');
      break;
    case 3:
      ret = moment(val).format('YYYY-MM-DD HH:mm:ss');
      break;
    case 4:
      ret = moment(val).format('YYYY-MM').replace('-','年') + '月';
      break;
    case 5:
      ret = moment(val).format('YYYY-MM-DD').replace('-','年').replace('-','月') + '日';
      break;
    case 6:
      ret = moment(val).valueOf()
      break
    case 7:
      ret = moment(val).format('HH:mm:ss');
      break
    default:
      ret = moment(val).format('YYYY-MM-DD');
  }
  return ret;
}
// 判断某个值是否是null或者undefined
export function isNullOrUndefined (val) {
  return ('' === val || null === val || 'null' === val || undefined === val || 'undefined' === val)
}
// 处理特殊字符
export function escape (content) {
  if (!content) return ''
  content = '' + content
  let _reg = /<br\/?>$/
  let _map = {
    r:/\<|\>|\&|\r|\n|\s|\'|\"/g,
    '<':'&lt;',
    '>':'&gt;',
    '&':'&amp;',
    ' ':'&nbsp;',
    '"':'&quot;',
    "'":'&#39;',
    '\n':'<br/>',
    '\r':''
  }
  content = content.replace(_map.r,  ($1) => {
    let _result = _map[!_map.i ? $1.toLowerCase() : $1]
    return _result != null ? _result : $1
  })
  return content.replace(_reg, '<br/>')
}
// 解析Url中的解析字符串
export function parseQueryString(url){
  let strIndex = url.indexOf('?')
  if(strIndex == -1) return null
  let strUrl = url.substring(strIndex+1, url.length)
  let data = strUrl.split('&')
  let obj = {}
  for(let i = 0; i<data.length; i++){
    let str = data[i]
    let index = str.indexOf('=')
    let key = str.substring(0,index)
    let val = str.substring(index+1, str.length)
    obj[key] = val
  }
  return obj
}
// 从Url中获取参数
export function getParamFromRoute(route, url = window.location.href){
  let urlObj = parseQueryString(url)
  if(urlObj){
    return Object.assign({},route.query, route.params, urlObj)
  }else{
    return Object.assign({},route.query, route.params)
  }
}
// 获取一个随机字符串
export function getRandowStr(len){
  let str = '';
  for ( ; str.length < len; str += Math.random().toString(36).substr(2) );
  return str.substr(0, len);
}
// 创建一个提示
export function toast({msg, type = 'error', title = '错误提示', duration = 2, onClose = null, onClick = null, placement = 'bottomRight' }) {
  notification.destroy()
  let config = {
    duration,
    message: title,
    description: msg,
    placement
  }
  if (onClose) config.onClose = onClose
  if (onClick) config.onClick = onClick
  if (type && (type === 'error' || type === 'info' || type === 'warning' || type === 'success')) {
    notification[type](config)
  }

}
// 验证传入日期是否过期
export function isDateOut (timeStr) {
  let nowDate = new Date().valueOf()
  let paramsTime = new Date(timeStr).valueOf()
  if ((nowDate - paramsTime) > 0) {
    return true
  }
  return false
}
// 预约时间补零
export function zeroPadding (num) {
  if (!num) return '00:00'
  let newNum = '' + num
  if (newNum && newNum.length === 1) {
    newNum = `000${newNum}`
  } else if (newNum && newNum.length === 2) {
    newNum = `00${newNum}`
  } else if (newNum && newNum.length === 3) {
    newNum = `0${newNum}`
  } else if (newNum && newNum.length === 4) {
    newNum
  }
  return `${newNum.substring(0, 2)}:${newNum.substring(2)}`
}
// 数组去重
export function arrayUnqiue (arr, name) {
  let hash = {}
  return arr.reduce((item, next) => {
    hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
    return item
  }, [])
}
// 将数组中相同的相加
export function addSameArr (arr) {
  let map = {}
  let newArr = []
  for (let i = 0; i < arr.length; i++) {
    let item = arr[i]
    if (!map[item.id]) {
      newArr.push(item)
      map[item.id] = item
    } else {
      for (let j = 0; j < newArr.length; j++) {
        let ele = newArr[j]
        if (ele.id === item.id) {
          ele.count = (parseFloat(ele.count) + parseFloat(item.count)).toString()
          ele.materialAmount = (parseFloat(ele.materialAmount) + parseFloat(item.materialAmount)).toString()
          break
        }
      }
    }
  }
  return newArr
}
// 计算年龄
export function computedAge (i_age_unit) {
  let mage = {
    age: 0,
    age_unit: 'Y'
  };
  let now = new Date()
  let days = (now.getTime() - i_age_unit) / 86400000;
  if (days <= 7) {
    mage.age_unit = 'D'
  } else if (days <= 60) {
    mage.age_unit = 'W'
  } else if (days <= 365) {
    mage.age_unit = 'M'
  } else {
    mage.age_unit = 'Y'
  }

  let mself = moment(i_age_unit)
  let mnow = moment(now)
  switch (mage.age_unit) {
    case 'Y':
      mage.age = mnow.diff(mself, 'years')
      break;
    case 'M':
      mage.age = mnow.diff(mself, 'months')
      break;
    case 'W':
      mage.age = mnow.diff(mself, 'weeks')
      break;
    case 'D':
      mage.age = mnow.diff(mself, 'days')
  }
  return mage;
}
/**
 * 获取预约日期
 * @val 传入Moment对象
 *  */
export function getReservationDate (val) {
  let now = moment()
  if (!val) {
    if (switchTimeFormat(now, 7) < '06:00:00') return now.add(-1, 'd')
    return now
  }
  let subDay = val.diff(now, 'days')
  if (subDay === 0 && switchTimeFormat(val, 7) < '06:00:00') return now.add(-1, 'd')
  return val
}
// 下载图片文件
export function downLoadBase64Image (fileName, content) {
  let base64ToBlob = function(code) {
    let parts = code.split(';base64,')
    let contentType = parts[0].split(':')[1]
    let raw = window.atob(parts[1])
    let rawLength = raw.length
    let uInt8Array = new Uint8Array(rawLength)
    for(let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {
      type: contentType
    })
  }
  let aLink = document.createElement('a')
  let evt = document.createEvent("HTMLEvents")
  evt.initEvent("click", true, true)
  aLink.download = fileName
  if (content.substring(0, 4) === 'http') {
    let image = new Image()
    let canvas = document.createElement("canvas")
    let context = canvas.getContext("2d")
    image.setAttribute('crossorigin', 'anonymous')
    image.onload = () => {
      canvas.width = image.width
      canvas.height = image.height
      context.drawImage(image, 0, 0, image.width, image.height)
      let url = canvas.toDataURL()
      aLink.href = URL.createObjectURL(base64ToBlob(url))
      aLink.click()
    }
    image.src = content
  } else {
    aLink.href = URL.createObjectURL(base64ToBlob(content))
    aLink.click()
  }
}
// 处理通知消息
export function dealMessageItem (msg) {
  let item = cloneDeep(msg)
  // 通知消息
  if (item.type === 'notification') return null
  // 文本消息
  if (item.type !== 'custom') return null
  try {
    item.content = JSON.parse(item.content)
    return item
  } catch (error) {
    console.log('解析JSON字符串错误', error)
    return {}
  }
}
// 跳转新页面
export function openNewWindow (path) {
  let url = window.location.protocol + '//' + window.location.host
  url = url + path
  return window.open(url, '_blank')
}
// 下载文件
export function downLoadFile (url, downloadName) {
  let aLink = document.createElement('a')
  if (downloadName) aLink.download = downloadName
  aLink.href = url
  aLink.click()
  aLink.remove()
}
// 返回文件的后缀地址
export function getFileSuffix (url) {
  if (!url) return ''
  let lastDotPos = url.lastIndexOf('.')
  let suffix = url.substring(lastDotPos + 1, url.length)
  return suffix
}
// 获取下一个月
export function getNextMonth (date) {
  let arr = date.split('-');
  let year = arr[0]; //获取当前日期的年份
  let month = arr[1]; //获取当前日期的月份
  let nextMonth = parseInt(month) + 1;
  let nextYear = year
  if (nextMonth == 13) {
      nextYear = parseInt(year) + 1;
      nextMonth = 1;
  }
  if (nextMonth < 10) {
    nextMonth = '0' + nextMonth;
  }
  var result = nextYear + '-' + nextMonth + '-' + '01' + ' ' + '00:00:00';
  return result;
}
// 处理数组为JSON字符串
export function arrToJson (arr) {
  if (!arr || arr.length <= 0) return false
  let jsonStr = JSON.stringify(arr)
  return jsonStr.slice(1, jsonStr.length - 1)
}
// 验证是否存在空格且处理
export function isSpace (str) {
  if (!str || str === '') return ''
  let newStr = ''
  if (str.indexOf(' ') !== -1) {
    for(let i = 0, len = str.length; i < len; i++) {
      if (str[i].indexOf(' ') !== -1) newStr += ''
      else newStr += str[i]
    }
    return newStr
  }
  return str
}

// 储存所需常量和变量
export function storeConstLet () {
  const editReportRouter = '/ris/edit'  // 编辑报告路由地址
  return {
    writing: 10, // 编写中
    auditing: 30, // 审核中
    waitAudit: 20, // 待审核
    isInEditReportRouter: isCurRouter(editReportRouter), // 是否处于编辑报告页面
    upLoad: 3, // 消息类型为全局弹框 上传影像
    unbundling: 4, // 消息类型为全局弹框 解绑影像
    toast: 1, // 消息类型为toast提示
    pay: 2 // 支付成功消息
  }
}

// 获取当前url的相对路径
export function getUrlRelativePath () {
  let url = document.location.toString();
  let arrUrl = url.split("//");
  let start = arrUrl[1].indexOf("/");
  let relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符
  if (relUrl.indexOf("?") !== -1) {
    relUrl = relUrl.split("?")[0];
  }
  return relUrl;
}

// 判断当前页面路由的与传入路由是否一致
export function isCurRouter (router) {
  if (!router) return false
  let curRouter = getUrlRelativePath()
  if (router === curRouter) {
    return true
  }
  return false
}

// 判断当前角色和传入角色是否一致
export function isRole (code) {
  if (!code) return false
  let roles = getSession('userAuth', 'object').roles || []
  for (let i = 0; i < roles.length; i++) {
    if (roles[i].rcode === code) return true
  }
}

// 判断是否为当前用户
export function isCurUser (users = []) {
  if (!users) return false
  let curUserId = getSession('risUserInfo', 'object').id || ''
  for (let i = 0, len = users.length; i < len; i++) {
    if (users[i] === curUserId) return true
    else return false
  }
}

// 上传影像弹框
export function uploadImg (data) {
  if (!data) return false
  let imageOperationLog = JSON.parse(data && data.content).imageOperationLog
  // let reportDetail = JSON.parse(data && data.content).report
  Modal.info({
    title: '上传影像',
    // okText: '去查看',
    closable: true,
    // cancelText: '返回',
    content: (h) => (
      <div>
        <p style="display: none;">{h}</p>
        <p style="color: #f00;font-weight: bold;">影像已更新，请重新查看影像，并调整报告内容</p>
        <p>患者：{imageOperationLog.patientName}</p>
        <p>技师：{imageOperationLog.creator}</p>
      </div>
    ),
    // onOk: (cancel) => {
    //   let curRouterIsEditReport = storeConstLet().isInEditReportRouter
    //   if (curRouterIsEditReport) {
    //     return new Promise((resolve) => {
    //       Bus.$emit('globalSaveReport:modal', reportDetail)
    //       resolve(cancel)
    //     })
    //   } else {
    //     return new Promise((resolve) => {
    //       let writing = 10
    //       let curUrl = window.location.origin
    //       if (reportDetail.status === writing) window.location.href = curUrl + `/ris/edit?reportId=${reportDetail.id}&from=writing`
    //       else window.location.href = curUrl + `/ris/edit?reportId=${reportDetail.id}`
    //       resolve(cancel)
    //     })
    //   }
    // },
    okButtonProps: { disabled: true}
  })
}

// 解绑影像
export function unbundlingImg (data) {
  if (!data) return false
  let imageOperationLog = JSON.parse(data && data.content).imageOperationLog
  // let reportDetail = JSON.parse(data && data.content).report
  Modal.info({
    title: '解绑影像',
    // okText: '去查看',
    // cancelText: '返回',
    closable: true,
    content: (h) => (
      <div>
        <p style="display: none;">{h}</p>
        <p style="color: #f00;font-weight: bold;">影像已解绑</p>
        <p style="color: #f00;font-weight: bold;">患者：{imageOperationLog.patientName}</p>
        <p>解绑技师：{imageOperationLog.creator}</p>
        <p>解绑原因：{imageOperationLog.change_reason}</p>
      </div>
    ),
    // onOk: (cancel) => {
    //   let curRouterIsEditReport = storeConstLet().isInEditReportRouter
    //   if (curRouterIsEditReport) {
    //     return new Promise((resolve) => {
    //       Bus.$emit('globalSaveReport:modal', reportDetail)
    //       resolve(cancel)
    //     })
    //   } else {
    //     return new Promise((resolve) => {
    //       let writing = 10
    //       let curUrl = window.location.origin
    //       if (reportDetail.status === writing) window.location.href = curUrl + `/ris/edit?reportId=${reportDetail.id}&from=writing`
    //       else window.location.href = curUrl + `/ris/edit?reportId=${reportDetail.id}`
    //       resolve(cancel)
    //     })
    //   }
    // },
  })
}

// 判断是否是上传和解绑影像消息
export function isUploadOrUnbundlingMsg (data) {
  let statement = storeConstLet() // if判断所需变量库
  if (data.msgType === statement.upLoad) { // 判断是否为上传影像消息
    uploadImg(data)
  } else if (data.msgType === statement.unbundling) { // 判断是否为解绑影像消息
    unbundlingImg(data)
  }
}

// 全局解绑和上传影像消息弹款逻辑
export function globalModalLogic (data) {
  let statement = storeConstLet() // if判断所需变量库
  if (isCurUser(data.receiveUserIdList)) { // 接受人是否为当前用户
    if (statement.writing && isRole('ROLE_WRITE_REPORT')) { // 报告编写中且是编写医生
      isUploadOrUnbundlingMsg(data)
      return
    }
    else if (statement.auditing && isRole('ROLE_AUDIT_REPORT')) { // 报告审核中且是审核医生
      isUploadOrUnbundlingMsg(data)
      return
    }
    else if (statement.waitAudit && isRole('ROLE_WRITE_REPORT')) { // 报告待审核且是编写医生
      isUploadOrUnbundlingMsg(data)
      return
    }
  }
}
export function globalModalPay (data) {
  if (isCurUser(data.receiveUserIdList)) {
    paySuccess(data)
  }
}
// 支付成功
export function paySuccess (data) {
  if (!data || !data.content) return false
  let payInfo = JSON.parse(data.content)
  let labelTitle = '检查部位：'
  if (payInfo.materials) labelTitle = '额外费用：'
  Modal.destroyAll()
  Modal.success({
    title: '支付成功',
    cancelText: '返回',
    content: (h) => (
      <div>
        <p style="display: none;">{h}</p>
        <p>姓名：{payInfo.name}</p>
        <p>电话：{payInfo.phone}</p>
        <p>{labelTitle}{payInfo.checkItems || payInfo.materials}</p>
        <p>总费用：{payInfo.totalAmount}</p>
        <p>收费渠道：{payInfo.payType}</p>
      </div>
    )
  })
}

export function checkPhone(phone){
  if(!phone) return false
  const re = /^1[0-9]\d{9}$/;
  if(re.test(phone)){
    return true
  }else{
    return false
  }
}
// 设置当前Url
export function setCurrentUrl (params) {
  let currentUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + `?`
  for (let k in params) currentUrl = `${currentUrl}&${k}=${params[k]}`
  currentUrl = currentUrl.replace(/\&/, '')
  window.history.replaceState(null, null, currentUrl)
}

// 获取姓名首字母（支持中英文）
export function getNameInitials(name) {
  if (!name || typeof name !== 'string') return ''
  name = name.trim()
  if (!name) return ''
  let initials = ''
  for (let i = 0; i < name.length; i++) {
    const char = name[i]
    if (/[a-zA-Z]/.test(char)) {
      if (i === 0 || !/[a-zA-Z]/.test(name[i - 1])) {
        initials += char.toUpperCase()
      }
    }
    else if (/[一-龥]/.test(char)) {
      const py = pinyin(char, { pattern: 'first', toneType: 'none' })
      initials += py.toUpperCase()
    }
  }
  return initials
}